import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
import { cookieUtils } from '../util/cookie.utils.js';
  
  class BureauService extends Service {
    constructor() {
      super();
  
      this.url = env.baseIdentificacao + "bureaus/";
    }

    async adquirirUserConnection() {
        const userConnectionId = cookieUtils.adquirirCookie('UserConnectionId');
        const bureau = await this.get(`${this.url}${userConnectionId}?include=userConnection`);
        const userConnection = bureau.included.find(include => include.type == 'user-connections');
        const userConnectionAttr = userConnection?.attributes;
        return userConnectionAttr;
    }
  }
  
  export const bureauService = new BureauService()
  